var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 38,
    viewBox: "0 0 47 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6196_23143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 30.2116C47 34.4159 43.7249 37.8395 39.7029 37.8395H0V7.62797C0 3.42358 3.27506 0 7.29707 0H47V30.2116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0723 22.4636H37.0888C37.175 22.4636 37.3761 22.4335 37.4622 22.4335C38.0368 22.3134 38.5252 21.7729 38.5252 21.0221C38.5252 20.3013 38.0368 19.7608 37.4622 19.6106C37.3761 19.5806 37.2037 19.5806 37.0888 19.5806H34.0723V22.4636Z",
    fill: "url(#paint0_linear_6196_23143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7437 2.55273C33.8708 2.55273 31.5151 4.98528 31.5151 8.01844V13.6944H38.8983C39.0707 13.6944 39.2718 13.6944 39.4154 13.7244C41.0817 13.8145 42.317 14.7154 42.317 16.2771C42.317 17.5084 41.4839 18.5595 39.9325 18.7697V18.8297C41.6275 18.9499 42.9203 19.9409 42.9203 21.4725C42.9203 23.1242 41.4839 24.2053 39.5878 24.2053H31.4863V35.317H39.1569C42.0297 35.317 44.3855 32.8844 44.3855 29.8512V2.55273H36.7437Z",
    fill: "url(#paint1_linear_6196_23143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1517 16.6373C38.1517 15.9165 37.6633 15.436 37.0888 15.3459C37.0313 15.3459 36.8877 15.3159 36.8015 15.3159H34.0723V17.9587H36.8015C36.8877 17.9587 37.06 17.9587 37.0888 17.9286C37.6633 17.8386 38.1517 17.3581 38.1517 16.6373Z",
    fill: "url(#paint2_linear_6196_23143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84327 2.55273C4.97041 2.55273 2.61467 4.98528 2.61467 8.01844V21.5025C4.07982 22.2533 5.60244 22.7338 7.12506 22.7338C8.93496 22.7338 9.91173 21.5926 9.91173 20.031V13.6643H14.3934V20.001C14.3934 22.4635 12.9282 24.4756 7.95819 24.4756C4.94168 24.4756 2.58594 23.7849 2.58594 23.7849V35.2869H10.2565C13.1293 35.2869 15.4851 32.8544 15.4851 29.8212V2.55273H7.84327Z",
    fill: "url(#paint3_linear_6196_23143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2931 2.55273C19.4202 2.55273 17.0645 4.98528 17.0645 8.01844V15.1659C18.386 13.9947 20.6843 13.2439 24.3902 13.4241C26.3725 13.5142 28.4984 14.0848 28.4984 14.0848V16.3972C27.4355 15.8266 26.1714 15.3161 24.5339 15.1959C21.7185 14.9857 20.0235 16.4272 20.0235 18.9499C20.0235 21.5025 21.7185 22.944 24.5339 22.7038C26.1714 22.5837 27.4355 22.0431 28.4984 21.5025V23.8149C28.4984 23.8149 26.4013 24.3855 24.3902 24.4756C20.6843 24.6558 18.386 23.905 17.0645 22.7338V35.347H24.735C27.6079 35.347 29.9636 32.9144 29.9636 29.8813V2.55273H22.2931Z",
    fill: "url(#paint4_linear_6196_23143)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6196_23143",
    x1: 31.5106,
    y1: 21.0257,
    x2: 44.4205,
    y2: 21.0257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6196_23143",
    x1: 31.5099,
    y1: 18.9217,
    x2: 44.4207,
    y2: 18.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6196_23143",
    x1: 31.5103,
    y1: 16.6335,
    x2: 44.4207,
    y2: 16.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6196_23143",
    x1: 2.60858,
    y1: 18.9217,
    x2: 15.7183,
    y2: 18.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6196_23143",
    x1: 16.9902,
    y1: 18.9217,
    x2: 29.7228,
    y2: 18.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6196_23143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.5e9bb75efa6f469b0cd02d4aa4b69aa8.svg";
export { ForwardRef as ReactComponent };